import { BannerText } from 'components/BannerText'
import { Header, TestimonialContainer, MeatBanner } from './Testimonial.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import Image from 'next/image'
import beef from '../../../../../public/assets/home/meat-close-up.webp'

export const Testimonial = () => {
  const { t } = useTranslation()
  return (
    <>
      <MeatBanner>
        <Image layout="fill" objectFit="cover" src={beef} alt={t('home:testimonial.image')} />
      </MeatBanner>
      <BannerText background="secondary-500">
        <TestimonialContainer>
          <Header>{t('home:testimonial.comment')}</Header>
          <Text className="author" size={{ '@initial': 'h5', '@bp2': 'h3' }} font="label">
            {t('home:testimonial.author')}
          </Text>
        </TestimonialContainer>
      </BannerText>
    </>
  )
}
